module.exports = __webpack_public_path__ + "static/img/pc_img_logo_content_paycools.7e6635dc.png";